<template>
  <div class="logo">
    <img src="@/assets/img/logo-big.png" alt="" height="38" />
  </div>
  <div class="sider_container">
    <a-menu v-model:selectedKeys="selectedKeys" mode="horizontal">
      <a-menu-item key="sub0">
        <template #icon>
          <HomeOutlined />
        </template>
         文件管理
      </a-menu-item>
      <a-menu-item key="sub1">
        <template #icon>
          <MailOutlined />
        </template>
        联系人管理
      </a-menu-item>
      <a-menu-item key="sub2">
        <template #icon>
          <FileTextOutlined />
        </template>
        日志管理
      </a-menu-item>
    </a-menu>
  </div>
</template>
<script setup>
import { ref, defineProps, computed } from 'vue';
import { MailOutlined, HomeOutlined, FileTextOutlined } from '@ant-design/icons-vue';
import { useRouter } from "vue-router";
const router = useRouter();
const props = defineProps({
  selected: {
    type: Array,
    default: ['sub0'],
  },
});
const selectedKeys = computed(() => props.selected);
</script>

<style lang='less' scoped>
.logo {
  margin-right: 64px;
}
/deep/.ant-menu-item-selected {
  background: rgba(245, 245, 255, 1);
}
/deep/.ant-menu-horizontal > .ant-menu-item::after {
  left: 0;
  right: 0;
}
</style>